/* eslint-disable react/display-name */
import { debounce, isEmpty } from 'lodash';
import Checkbox from '@shared/component/Checkbox';
import {
    DateFormatPicker,
    TextTruncate,
    actionsPermissionValidator,
    checkUrlString,
    ActionValues,
} from '@utils/static/commonUtils';
import React, { useEffect, useState, useImperativeHandle, forwardRef, useRef } from 'react';
import { IconContext } from 'react-icons';
import { AiFillLeftCircle, AiFillRightCircle } from 'react-icons/ai';
import ReactPaginate from 'react-paginate';
import { NavLink } from 'react-router-dom';
import StatusDropDown from './StatusDropDown';
import BulkUpload from './BulkUpload';
import moment from 'moment';
import { default as loader } from '../../assets/images/loaderanimated.svg';
import GlobalSearch from './GlobalSearch';
import ReactStars from 'react-rating-stars-component';

const List = forwardRef((props: any, ref) => {
    const childRef: any = useRef(null);
    const [deleteshow, setDeleteShow] = useState(false);
    const [search, setSearch] = useState('');
    const [list, setlist] = useState([]);
    const [allChecked, setallChecked] = useState(false);
    const [deleteIds, setDeleteIds] = useState<number[]>([]);
    const [showHideModel, setShowHideModel] = useState(false);
    const [showAddButton, setshowAddButton] = useState(true);
    const [page, setPage] = useState(1);
    const [filterData, setFilterData] = useState<any[]>([]);
    const [showLoader, setshowLoader] = useState(false);
    const [listCount, setlistCount] = useState(false);
    const [searchText, setSearchText] = useState<any>(null);
    const recordPerPage: any = process.env.REACT_APP_RECORD_PER_PAGE;
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        setlist(props.list);
        if (props?.list?.length == 0) {
            setlistCount(true);
        }
        setshowLoader(false);
    }, [props.list]);

    // useEffect(() => {
    //     setshowAddButton(props.showAddButton);
    // }, [props.showAddButton]);

    const handleSelectAll = () => {
        try {
            setallChecked(!allChecked);
            setDeleteIds(list.map((i: any) => i.id));
            if (allChecked) {
                setDeleteIds([]);
            }
        } catch (error) { }
    };

    const handleCancel = () => {
        setallChecked(false);
        setDeleteIds([]);
    };

    const handleClick = (e: any) => {
        try {
            const { id, checked } = e.target;
            const idd = parseInt(id);
            setDeleteIds([...deleteIds, idd]);
            if (!checked) {
                setDeleteIds(deleteIds.filter(item => item !== idd));
                setallChecked(false);
            }
        } catch (error) { }
    };

    const callDelete = () => {
        try {
            props.getDeleteIds(deleteIds);
            setDeleteShow(false);
            setDeleteIds([]);
        } catch (error) { }
    };

    const handelModel = (flag: boolean) => {
        try {
            props.handelModel(flag);
        } catch (error) { }
    };

    const checkResnedValid = item => {
        let status = false;
        try {
            const date1 = moment(item.createdAt);
            const date2 = moment();
            const daysDifference = date2.diff(date1, 'hours');
            if (
                isEmpty(item?.documents?.pincode) &&
                isEmpty(item?.documents?.aadharNo) &&
                isEmpty(item?.documents?.panNo) &&
                item.documentStatus == 'Pending' &&
                daysDifference > 48
            ) {
                status = true;
            }
            return status;
        } catch (error) {
            return status;
        }
    };

    const listLog = list.map((item: any, index) => {
        const vendor =
            item?.app_users?.length > 0 &&
            item.app_users.map((data: any, index: number) => {
                if (item.app_users.length > 1) {
                    return index === item.app_users.length - 1 ? data.name : data.name + ', ';
                } else {
                    return data.name;
                }
            });
        return (
            <tr key={index}>
                <td
                    className="check_box option_box sorting_1"
                    style={deleteshow ? { display: 'table-cell' } : { display: 'none' }}
                >
                    <Checkbox
                        key={item.id}
                        type="checkbox"
                        name={`${item.id}-checkbox`}
                        id={item.id}
                        handleClick={handleClick}
                        isChecked={deleteIds.includes(item.id)}
                    />
                </td>

                {props && props.type === 'finalised' && (
                    <>
                        <td>
                            <a
                                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                onClick={() => props.demandModel(item.id)}
                            >
                                {item.demandId}
                            </a>
                        </td>
                    </>
                )}
                {props && props.type === 'finalised' && (
                    <>
                        <td>{item.id}</td>
                    </>
                )}

                {props?.type === 'finalised_other_vendor' && (
                    // <tr>
                    <td>
                        <a
                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => props.otherdemandModel(item.id)}
                        >
                            {item.demandOthersId}
                        </a>
                    </td>
                    // </tr>
                )}

                {props && props.type === 'finalised_other_vendor' && (
                    <>
                        <td>{item.id}</td>
                    </>
                )}

                {props?.type === 'signup' ? <> {item?.name && <td>{item.name}</td>}</> : ''}
                {props?.type === 'signup' ? <> {item?.phone && <td>{item.phone}</td>}</> : ''}
                {props?.type === 'signup' ? <> {item?.category?.name && <td>{item.category.name}</td>}</> : ''}

                {props?.type === 'location' ? <> {item?.pincode && <td>{item.pincode}</td>}</> : ''}
                {props?.type === 'location' ? <> {item?.state && <td>{item.state}</td>}</> : ''}
                {props?.type === 'location' ? <> {item?.city && <td>{item.city}</td>}</> : ''}
                {props?.type === 'item' ? <>{item?.name && <td>{item.name}</td>}</> : ''}
                {props?.type === 'item' ? <>{item?.category?.name && <td>{item.category?.name}</td>}</> : ''}
                {props?.type === 'item' ? <>{item?.type && <td>{item.type}</td>}</> : ''}

                {item?.penaltyType && <td>{item.penaltyType}</td>}
                {item?.durationOfDelay && <td>{item.durationOfDelay}</td>}
                {item?.penaltyAmount && <td>{item.penaltyAmount}</td>}
                {item?.bidType && <td>{item.bidType}</td>}
                {props?.type === 'transporter' ? (
                    <> {item?.pickUpDate && <td>{DateFormatPicker(item.pickUpDate)}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'transporter' ? <> {item?.from?.city && <td>{item.from.city}</td>}</> : ''}
                {props?.type === 'transporter' ? <> {item?.to?.city && <td>{item.to.city}</td>}</> : ''}
                {props?.type !== 'signup' &&
                    props?.type !== 'transporter' &&
                    props.type !== 'app_transporter' &&
                    props.type !== 'item' && <>{item?.category?.name && <td>{item.category.name}</td>}</>}
                {props?.type === 'transporter' ? '' : <>{item?.item?.name && <td>{item.item.name}</td>}</>}
                {props?.type === 'transporter' ? '' : <>{item?.quantity && <td>{item.quantity}</td>}</>}
                {props?.type === 'transporter' ? '' : <>{item?.itemUnit && <td>{item.itemUnit}</td>}</>}
                {item?.deliveryDate && <td>{DateFormatPicker(item.deliveryDate, 'DD-MMM-YYYY hh:mm A')}</td>}
                {/* {item?.description ? <td>{TextTruncate(item.description, 50, true)}</td> : (props?.type === 'transporter') && <td></td>} */}

                {props?.type === 'finalised_other_vendor' &&
                    item?.app_user?.name &&
                    item?.demand?.category?.name !== 'transporter' && (
                        <td>{TextTruncate(item.app_user.name, 25, true)}</td>
                    )}
                {props?.type === 'finalised_other_vendor' &&
                    item?.app_user?.phone &&
                    item?.demand?.category?.name !== 'transporter' && <td>{item.app_user.phone}</td>}

                {props?.type === 'finalised_other_vendor' &&
                    item?.demand?.category &&
                    item?.demand?.category?.name !== 'transporter' && <td>{item.demand.category.name}</td>}

                {props?.type === 'finalised_other_vendor' ? (
                    <>{item?.demand?.item && <td>{item.demand.item.name}</td>}</>
                ) : (
                    ''
                )}

                {props?.type === 'finalised_other_vendor' ? (
                    <>
                        {item?.demand?.category?.name !== 'transporter' && (
                            <>
                                {item?.deliveryStatus !== null ? (
                                    <td>
                                        {item.deliveryStatus === 'notArrived' ? (
                                            <>
                                                <span className="table_status_btn denied_btn">
                                                    <b>Not Arrived</b>
                                                </span>
                                            </>
                                        ) : item.deliveryStatus === 'arrived' || item.deliveryStatus === 'delivered' ? (
                                            <span className="table_status_btn deliverd_btn">
                                                <b>Delivered</b>
                                            </span>
                                        ) : item.deliveryStatus === 'cancelled' ? (
                                            <span className="table_status_btn denied_btn">
                                                <b>Cancelled</b>
                                            </span>
                                        ) : (
                                            <span className="table_status_btn denied_btn"></span>
                                        )}
                                    </td>
                                ) : (
                                    <td>{'-'}</td>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    ''
                )}

                {props?.type === 'finalised_other_vendor' && item?.demand?.category?.name !== 'transporter' ? (
                    <>
                        {item?.rating_appUser?.rating ? (
                            <td>
                                <ReactStars
                                    count={5}
                                    value={item.rating_appUser.rating}
                                    size={19}
                                    isHalf={true}
                                    emptyIcon={<i className="fa fa-star" style={{ color: 'green' }}></i>}
                                    halfIcon={<i className="fa fa-star-half-alt" style={{ color: 'white' }}></i>}
                                    fullIcon={<i className="fa fa-star" style={{ color: 'white' }}></i>}
                                    activeColor="#FFA800"
                                    edit={false}
                                />
                            </td>
                        ) : (
                            <td>{'-'}</td>
                        )}
                    </>
                ) : (
                    ''
                )}

                {props?.type === 'finalised' ? (
                    <>{item?.app_user?.companyname && <td title={item.app_user.companyname}>{TextTruncate(item.app_user.companyname, 25, true)}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'finalised' ? (
                    <>{<td>{item?.demand?.to?.city}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'finalised' ? <>{item?.app_user?.phone && <td>{item.app_user.phone}</td>}</> : ''}
                {props?.type === 'finalised' ? (
                    <>
                        {item?.rating_appUser?.rating ? (
                            <td>
                                <ReactStars
                                    count={5}
                                    value={item.rating_appUser.rating}
                                    size={19}
                                    isHalf={true}
                                    emptyIcon={<i className="fa fa-star" style={{ color: 'green' }}></i>}
                                    halfIcon={<i className="fa fa-star-half-alt" style={{ color: 'white' }}></i>}
                                    fullIcon={<i className="fa fa-star" style={{ color: 'white' }}></i>}
                                    activeColor="#FFA800"
                                    edit={false}
                                />
                            </td>
                        ) : (
                            <td>{'-'}</td>
                        )}
                    </>
                ) : (
                    ''
                )}
                {/* {props?.type === 'finalised' ? (
                    <>
                        {item?.rating_appUser !== null && item?.rating_appUser?.remark !== '' ? (
                            <td>{item.rating_appUser?.remark}</td>
                        ) : (
                            <td className="text-center">-</td>
                        )}
                    </>
                ) : (
                    ''
                )} */}
                {props?.type === 'finalised' ? (
                    <>
                        {item?.deliveryStatus !== null ? (
                            <td>
                                {item.deliveryStatus === 'notArrived' ? (
                                    <span className="table_status_btn denied_btn">
                                        <b>Not Arrived</b>
                                    </span>
                                ) : item.deliveryStatus == 'dispatched' ? (
                                    <span className="table_status_btn dispatched_btn">
                                        <b>dispatched</b>
                                    </span>
                                ) : item.deliveryStatus == 'delivered' ? (
                                    <span className="table_status_btn deliverd_btn ">
                                        <b>Delivered</b>
                                    </span>
                                ) : item.deliveryStatus == 'cancelled' ? (
                                    <span className="table_status_btn denied_btn ">
                                        <b>Cancelled</b>
                                    </span>
                                ) : (
                                    <span className="table_status_btn arrived_btn ">
                                        <b>Arrived</b>
                                    </span>
                                )}
                            </td>
                        ) : (
                            <td>{'-'}</td>
                        )}
                    </>
                ) : (
                    ''
                )}
                {/* {props?.type === 'finalised' ? (
                    <>
                        {item?.actualDeliveryDate !== null ? (
                            <td>{DateFormatPicker(item.actualDeliveryDate, 'DD-MMM-YYYY hh:mm A')}</td>
                        ) : (
                            <td className="text-center">{'-'}</td>
                        )}
                    </>
                ) : (
                    ''
                )} */}
                {/* {props?.type === 'finalised' ? (
                    <>{item?.remark !== null ? <td>{item.remark}</td> : <td>{'-'}</td>}</>
                ) : (
                    ''
                )} */}
                {props?.type === 'vendordelay' ? <>{item?.app_user?.name && <td>{item.app_user.name}</td>}</> : ''}
                {props?.type === 'vendordelay' ? <>{item?.app_user?.phone && <td>{item.app_user.phone}</td>}</> : ''}
                {props?.type === 'vendordelay' ? (
                    <>{item?.app_user?.category?.name && <td>{item.app_user.category.name}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'vendordelay' ? (
                    <>
                        {item?.expectedDeliveryDate !== null ? (
                            <td>{DateFormatPicker(item.expectedDeliveryDate, 'DD-MMM-YYYY hh:mm A')}</td>
                        ) : (
                            <td className="text-center">{'-'}</td>
                        )}
                    </>
                ) : (
                    ''
                )}
                {props?.type === 'vendordelay' ? (
                    <>
                        {item?.actualDeliveryDate !== null ? (
                            <td>{DateFormatPicker(item.actualDeliveryDate, 'DD-MMM-YYYY hh:mm A')}</td>
                        ) : (
                            <td className="text-center">{'-'}</td>
                        )}
                    </>
                ) : (
                    ''
                )}
                {props?.type === 'vendordelay' ? (
                    <>{item?.penalty?.penaltyType && <td>{item.penalty?.penaltyType}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'vendordelay' ? (
                    <>{item?.penalty?.penaltyAmount && <td>{item.penalty?.penaltyAmount}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'othersbids' ? <>{item?.app_user?.name && <td>{item?.app_user?.name}</td>}</> : ''}
                {props?.type === 'transporterbids' ? (
                    <>{item?.app_user?.name && <td>{item?.app_user?.name}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'othersbids' ? (
                    <>{item?.app_user?.category?.name && <td>{item?.app_user?.category?.name}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'othersbids' ? (
                    <>{item?.createdAt && <td>{DateFormatPicker(item?.createdAt, 'DD-MMM-YYYY hh:mm A')}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'transporterbids' ? (
                    <>{item?.createdAt && <td>{DateFormatPicker(item?.createdAt, 'DD-MMM-YYYY hh:mm A')}</td>}</>
                ) : (
                    ''
                )}
                {props?.type === 'othersbids' ? <>{item?.rate && <td>{item?.rate}</td>}</> : ''}
                {props?.type === 'transporterbids' ? <>{item?.rate && <td>{item?.rate}</td>}</> : ''}
                {props?.type === 'othersbids' ? (
                    <>
                        {item?.expectedDeliveryDate && (
                            <td>{DateFormatPicker(item?.expectedDeliveryDate, 'DD-MMM-YYYY hh:mm A')}</td>
                        )}
                    </>
                ) : (
                    ''
                )}
                {props?.type === 'transporterbids' ? (
                    <>
                        {item?.expectedDeliveryDate && (
                            <td>{DateFormatPicker(item?.expectedDeliveryDate, 'DD-MMM-YYYY hh:mm A')}</td>
                        )}
                    </>
                ) : (
                    ''
                )}
                {props?.type === 'Role' && <>{item?.name && <td>{item.name}</td>}</>}
                {/* {item?.user_permissions?.length && (
                    <td>
                        {item?.user_permissions?.length > 0 &&
                            item.user_permissions.map((permission: any, idx: any) => (
                                <span key={idx}>
                                    {permission.name}
                                    {idx !== item.user_permissions.length - 1 && ', '}
                                </span>
                            ))}
                    </td>
                )} */}
                {props?.type === 'app_transporter' && (
                    <>
                        {item?.companyname && <td>{item.companyname}</td>}
                        {item?.name && <td>{item.name}</td>}
                        {item?.phone && <td>{item.phone}</td>}
                    </>
                )}
                {props?.type === 'userMangement' ? <> {item?.phone && <td>{item.phone}</td>}</> : ''}
                {props?.type === 'userMangement' ? <> {item?.name && <td>{item.name}</td>}</> : ''}
                {props?.type === 'category' ? <>{item?.name && <td>{item.name}</td>}</> : ''}
                {props?.type === 'category' && <td>{item?.items?.length > 0 ? item.items.length : 0}</td>}
                {item?.user_role && <td>{item.user_role.name}</td>}
                {props?.type === 'othersbids' ||
                    props?.type === 'transporterbids' ||
                    props?.type === 'finalised' ||
                    props?.type === 'finalised_other_vendor' ||
                    props?.type === 'vendordelay' ? (
                    ''
                ) : (
                    <td className="text-center">
                        {props?.showAddButton === false && item ? (
                            <StatusDropDown item={item} updateStatus={props.updateStatus} />
                        ) : (
                            <>
                                {' '}
                                {props.type === 'transporter' || props.type === 'others' ? (
                                    <>
                                        {item.status === 'completed' ? (
                                            <span className="text-center text-secondary">Completed</span>
                                        ) : (
                                            <div
                                                className={
                                                    item.status === 'active'
                                                        ? 'dropdown dropdown_status_box'
                                                        : 'dropdown dropdown_status_box inactive_status_box'
                                                }
                                            >
                                                <button
                                                    className="btn btn-secondary dropdown-toggle capitalize"
                                                    type="button"
                                                    id="dropdownMenuButton1"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    {item?.status}
                                                </button>
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                    <li>
                                                        <a
                                                            className={
                                                                item.status === 'active'
                                                                    ? 'dropdown-item active'
                                                                    : 'dropdown-item'
                                                            }
                                                            href="javascript:void(0)"
                                                            onClick={() => {
                                                                props.updateStatus(item, 'active', item.id, page);
                                                            }}
                                                        >
                                                            Active
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            className={
                                                                item.status === 'active'
                                                                    ? 'dropdown-item '
                                                                    : 'dropdown-item active'
                                                            }
                                                            href="javascript:void(0)"
                                                            onClick={() => {
                                                                props.updateStatus(item, 'inactive', item.id, page);
                                                            }}
                                                        >
                                                            Inactive
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div
                                        className={
                                            item.status === 'active'
                                                ? 'dropdown dropdown_status_box'
                                                : 'dropdown dropdown_status_box inactive_status_box'
                                        }
                                    >
                                        <button
                                            className="btn btn-secondary dropdown-toggle capitalize"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {item?.status}
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li>
                                                <a
                                                    className={
                                                        item.status === 'active'
                                                            ? 'dropdown-item active'
                                                            : 'dropdown-item'
                                                    }
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                        props.updateStatus(item, 'active', item.id, page);
                                                    }}
                                                >
                                                    Active
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className={
                                                        item.status === 'active'
                                                            ? 'dropdown-item '
                                                            : 'dropdown-item active'
                                                    }
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                        props.updateStatus(item, 'inactive', item.id, page);
                                                    }}
                                                >
                                                    Inactive
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </>
                        )}

                        {/* <div
                            className={
                                item.status === 'active'
                                    ? 'dropdown dropdown_status_box'
                                    : 'dropdown dropdown_status_box inactive_status_box'
                            }
                        >
                            <button
                                className="btn btn-secondary dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {item?.status}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li>
                                    <a
                                        className={item.status === 'active' ? 'dropdown-item active' : 'dropdown-item'}
                                        href="javascript:void(0)"
                                        onClick={() => {
                                            props.updateStatus(item, 'active', item.id);
                                        }}
                                    >
                                        Active
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className={item.status === 'active' ? 'dropdown-item ' : 'dropdown-item active'}
                                        href="javascript:void(0)"
                                        onClick={() => {
                                            props.updateStatus(item, 'inactive', item.id);
                                        }}
                                    >
                                        Inactive
                                    </a>
                                </li>
                            </ul>
                        </div> */}
                    </td>
                )}
                <td>
                    {props?.type === 'othersbids' || props?.type === 'transporterbids' ? (
                        <button
                            className="btn blue_btn custom_btn"
                            onClick={() => {
                                props.getById(item.id);
                            }}
                        >
                            View
                        </button>
                    ) : props?.type === 'finalised' ? (
                        actionsPermissionValidator(location.pathname, ActionValues.Edit) ||
                            actionsPermissionValidator(location.pathname, ActionValues.View) ? (
                            <>
                                {item.deliveryStatus == 'arrived' || item.deliveryStatus == 'dispatched' ? (
                                    <div className="d-flex justify-content-left justifyCenter">
                                        {actionsPermissionValidator(location.pathname, ActionValues.View) ? (
                                            <button
                                                className="btn viewlightblue_btn custom_btn"
                                                onClick={() => {
                                                    props.getById(item.id, 'view');
                                                }}
                                            >
                                                view
                                            </button>
                                        ) : (
                                            ''
                                        )}
                                        &nbsp;&nbsp;
                                        {actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                            <button
                                                className="btn bidsblue_btn custom_btn"
                                                onClick={() => {
                                                    props.getById(item.id);
                                                }}
                                            >
                                                Update Status
                                            </button>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                ) : item.deliveryStatus == 'delivered' ||
                                    item.deliveryStatus == 'notArrived' ||
                                    item.deliveryStatus == 'cancelled' ? (
                                    <div className="d-flex justify-content-left justifyCenter">
                                        {actionsPermissionValidator(location.pathname, ActionValues.View) ? (
                                            <button
                                                className="btn viewlightblue_btn custom_btn"
                                                onClick={() => {
                                                    props.getById(item.id, 'view');
                                                }}
                                            >
                                                view
                                            </button>
                                        ) : (
                                            ''
                                        )}
                                        &nbsp;&nbsp;
                                        {item?.rating_appUser?.rating == undefined ? (
                                            actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                                <button
                                                    className="btn rateNowblue_btn custom_btn"
                                                    onClick={() => {
                                                        props.getById(item.id, 'rating');
                                                    }}
                                                >
                                                    Rate Transporter
                                                </button>
                                            ) : (
                                                ''
                                            )
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                ) : (
                                    <div className="d-flex justify-content-left justifyCenter">
                                        {actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                            <button
                                                className="btn bidsblue_btn custom_btn"
                                                onClick={() => {
                                                    props.getById(item.id);
                                                }}
                                            >
                                                Update Status
                                            </button>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                )}
                            </>
                        ) : (
                            ''
                        )
                    ) : props?.type === 'finalised_other_vendor' ? (
                        <>{item.deliveryStatus == ''}</>
                    ) : (
                        <></>
                    )}

                    {props?.type === 'finalised_other_vendor' &&
                        (actionsPermissionValidator(location.pathname, ActionValues.Edit) ||
                            actionsPermissionValidator(location.pathname, ActionValues.View) ? (
                            <>
                                {item.deliveryStatus === 'arrived' ||
                                    item.deliveryStatus === 'delivered' ||
                                    item.deliveryStatus === 'notArrived' ||
                                    item.deliveryStatus === 'cancelled' ? (
                                    <>
                                        {actionsPermissionValidator(location.pathname, ActionValues.View) ? (
                                            <button
                                                className="btn viewlightblue_btn custom_btn"
                                                onClick={() => {
                                                    props.getById(item.id, 'view');
                                                }}
                                            >
                                                View
                                            </button>
                                        ) : (
                                            ''
                                        )}
                                        &nbsp;&nbsp;
                                        {item?.rating_appUser == undefined ? (
                                            actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                                <button
                                                    className="btn rateNowblue_btn custom_btn"
                                                    onClick={() => {
                                                        props.getById(item.id, 'rating');
                                                    }}
                                                >
                                                    Rate Vendor
                                                </button>
                                            ) : (
                                                ''
                                            )
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                ) : actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                    <button
                                        className="btn bidsblue_btn custom_btn"
                                        onClick={() => {
                                            props.getById(item.id);
                                        }}
                                    >
                                        Update Status
                                    </button>
                                ) : (
                                    ''
                                )}
                            </>
                        ) : (
                            ''
                        ))}

                    {props?.type === 'transporter' ? (
                        <>
                            &nbsp;
                            <NavLink
                                to={`/home/bids/transporter/${item.id}/${item?.from?.city + '-' + item?.to?.city}`}
                                className="btn bidsblue_btn custom_btn"
                            >
                                <img
                                    className="img-fluid "
                                    style={{ width: '18px' }}
                                    src="assets/images/bids.png"
                                    alt=""
                                />{' '}
                                Bids
                            </NavLink>
                        </>
                    ) : (
                        ''
                    )}
                    {props?.type === 'others' ? (
                        <>
                            &nbsp;
                            <NavLink
                                to={`/home/bids/others/${item.id}/${item?.item?.name}`}
                                className="btn bidsblue_btn custom_btn"
                            >
                                <img
                                    className="img-fluid "
                                    style={{ width: '18px' }}
                                    src="assets/images/bids.png"
                                    alt=""
                                />{' '}
                                Bids
                            </NavLink>
                        </>
                    ) : (
                        ''
                    )}
                </td>
            </tr>
        );
    });

    const listLogAppTransporter = list.map((item: any, index) => {
        return (
            <tr key={index}>
                <td
                    className="check_box option_box sorting_1"
                    style={deleteshow ? { display: 'table-cell' } : { display: 'none' }}
                >
                    <Checkbox
                        key={item.id}
                        type="checkbox"
                        name={`${item.id}-checkbox`}
                        id={item.id}
                        handleClick={handleClick}
                        isChecked={deleteIds.includes(item.id)}
                    />
                </td>

                {props?.type === 'app_transporter' && (
                    <>
                        {item?.id && <td>{item.id}</td>}
                        {item?.companyname ? <td>{item.companyname}</td> : <td></td>}
                        {item?.name && <td>{TextTruncate(item.name.toString(), 10, true)}</td>}
                        {item?.phone && <td>{item.phone}</td>}
                        {item?.document_transporter?.gstDoc ? (
                            <td>
                                <a
                                    target="_blank"
                                    className="text-primary"
                                    rel="noreferrer"
                                    href={`${process.env.REACT_APP_API_BASE}${checkUrlString(
                                        item?.document_transporter?.gstDoc,
                                    )}`}
                                >
                                    <u>View</u>
                                </a>
                            </td>
                        ) : (
                            <td></td>
                        )}
                        {item?.document_transporter?.panDoc ? (
                            <td>
                                <a
                                    target="_blank"
                                    className="text-primary"
                                    rel="noreferrer"
                                    href={`${process.env.REACT_APP_API_BASE}${checkUrlString(
                                        item?.document_transporter?.panDoc,
                                    )}`}
                                >
                                    <u>View</u>
                                </a>
                            </td>
                        ) : (
                            <td></td>
                        )}
                        {item?.document_transporter?.idProof ? (
                            <td>
                                <a
                                    target="_blank"
                                    className="text-primary"
                                    rel="noreferrer"
                                    href={`${process.env.REACT_APP_API_BASE}${checkUrlString(
                                        item?.document_transporter?.idProof,
                                    )}`}
                                >
                                    <u>View</u>
                                </a>
                            </td>
                        ) : (
                            <td></td>
                        )}
                        {item?.document_transporter?.otherDoc ? (
                            <td>
                                <a
                                    target="_blank"
                                    className="text-primary"
                                    rel="noreferrer"
                                    href={`${process.env.REACT_APP_API_BASE}${checkUrlString(
                                        item?.document_transporter?.otherDoc,
                                    )}`}
                                >
                                    <u>View</u>
                                </a>
                            </td>
                        ) : (
                            <td></td>
                        )}
                    </>
                )}
                <td>
                    <div
                        className={
                            item.status === 'active'
                                ? 'dropdown dropdown_status_box'
                                : 'dropdown dropdown_status_box inactive_status_box'
                        }
                    >
                        <button
                            className="btn btn-secondary dropdown-toggle capitalize"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {item?.status}
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                                <a
                                    className={item.status === 'active' ? 'dropdown-item active' : 'dropdown-item'}
                                    href="javascript:void(0)"
                                    onClick={() => {
                                        props.updateStatus(item, 'active', item.id, page);
                                    }}
                                >
                                    Active
                                </a>
                            </li>
                            <li>
                                <a
                                    className={item.status === 'active' ? 'dropdown-item ' : 'dropdown-item active'}
                                    href="javascript:void(0)"
                                    onClick={() => {
                                        props.updateStatus(item, 'inactive', item.id, page);
                                    }}
                                >
                                    Inactive
                                </a>
                            </li>
                        </ul>
                    </div>
                </td>
                <td>
                    <>
                        <div className="d-flex justify-content-left">
                            {actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                <>
                                    <button
                                        className="btn blue_btn custom_btn"
                                        onClick={() => {
                                            props.getById(item.id, 'edit');
                                        }}
                                    >
                                        <img className="img-fluid" src="assets/images/edit.svg" alt="" /> Edit
                                    </button>
                                </>
                            ) : (
                                ''
                            )}
                            &nbsp;
                            <button
                                className="btn blue_btn custom_btn"
                                style={{ backgroundColor: '#022d4a', color: 'white' }}
                                onClick={() => {
                                    props.getById(item.id, 'view');
                                }}
                            >
                                View
                            </button>
                        </div>
                    </>
                </td>
            </tr>
        );
    });

    const listLogAppOthers = list?.map((item: any, index) => {
        return (
            <tr key={index}>
                <td
                    className="check_box option_box sorting_1"
                    style={deleteshow ? { display: 'table-cell' } : { display: 'none' }}
                >
                    <Checkbox
                        key={item.id}
                        type="checkbox"
                        name={`${item.id}-checkbox`}
                        id={item.id}
                        handleClick={handleClick}
                        isChecked={deleteIds.includes(item.id)}
                    />
                </td>
                {item?.id && <td>{item.id}</td>}
                {item?.companyname ? <td>{item.companyname}</td> : <td></td>}
                {item?.name && <td>{item.name}</td>}
                {item?.phone && <td>{item.phone}</td>}
                {item?.category?.name && <td>{item?.category?.name}</td>}
                {/* {item?.items && <td>{item?.items?.map((ele: any) => ele.name).join(',')}</td>} */}
                {item?.other_document?.gstDoc ? (
                    <td>
                        <a
                            target="_blank"
                            className="text-primary"
                            rel="noreferrer"
                            href={`${process.env.REACT_APP_API_BASE}${checkUrlString(item?.other_document?.gstDoc)}`}
                        >
                            <u>View</u>
                        </a>
                    </td>
                ) : (
                    <td></td>
                )}
                {item?.other_document?.panDoc ? (
                    <td>
                        <a
                            target="_blank"
                            className="text-primary"
                            rel="noreferrer"
                            href={`${process.env.REACT_APP_API_BASE}${checkUrlString(item?.other_document?.panDoc)}`}
                        >
                            <u>View</u>
                        </a>
                    </td>
                ) : (
                    <td></td>
                )}
                {item?.other_document?.idProof ? (
                    <td>
                        <a
                            target="_blank"
                            className="text-primary"
                            rel="noreferrer"
                            href={`${process.env.REACT_APP_API_BASE}${checkUrlString(item?.other_document?.idProof)}`}
                        >
                            <u>View</u>
                        </a>
                    </td>
                ) : (
                    <td></td>
                )}
                {item?.other_document?.otherDoc ? (
                    <td>
                        <a
                            target="_blank"
                            className="text-primary"
                            rel="noreferrer"
                            href={`${process.env.REACT_APP_API_BASE}${checkUrlString(item?.other_document?.otherDoc)}`}
                        >
                            <u>View</u>
                        </a>
                    </td>
                ) : (
                    <td></td>
                )}

                <td>
                    <div
                        className={
                            item.status === 'active'
                                ? 'dropdown dropdown_status_box'
                                : 'dropdown dropdown_status_box inactive_status_box'
                        }
                    >
                        <button
                            className="btn btn-secondary dropdown-toggle capitalize"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {item?.status}
                        </button>

                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                                <a
                                    className={item.status === 'active' ? 'dropdown-item active' : 'dropdown-item'}
                                    href="javascript:void(0)"
                                    onClick={() => {
                                        props.updateStatus(item, 'active', item.id, page);
                                    }}
                                >
                                    Active
                                </a>
                            </li>
                            <li>
                                <a
                                    className={item.status === 'active' ? 'dropdown-item ' : 'dropdown-item active'}
                                    href="javascript:void(0)"
                                    onClick={() => {
                                        props.updateStatus(item, 'inactive', item.id, page);
                                    }}
                                >
                                    Inactive
                                </a>
                            </li>
                        </ul>
                    </div>
                </td>
                {/* <td className="alignmiddle"> */}
                <td>
                    <>
                        <div className="d-flex justify-content-left">
                            {actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                <button
                                    className="btn blue_btn custom_btn"
                                    onClick={() => {
                                        props.getById(item.id, 'edit');
                                    }}
                                >
                                    <img className="img-fluid" src="assets/images/edit.svg" alt="" /> Edit66
                                </button>
                            ) : (
                                ''
                            )}
                            &nbsp;
                            <button
                                className="btn blue_btn custom_btn"
                                style={{ backgroundColor: '#022d4a', color: 'white' }}
                                onClick={() => {
                                    props.getById(item.id, 'view');
                                }}
                            >
                                View
                            </button>
                        </div>
                    </>
                </td>
            </tr>
        );
    });

    const getPage = (e: any) => {
        try {
            setPage(e + 1);
            if (searchText?.trim().length > 0) {
                props.searchItem(searchText.trim(), e + 1);
            } else {
                props.callPagination(e + 1);
            }
            setDeleteShow(false);
            setDeleteIds([]);
            setallChecked(false);
        } catch (error) { }
    };

    const getSearchData = search => {
        try {
            setlist([]);
            setSearchText(search.trim());
            props.searchItem(search.trim(), 1);
            setDeleteShow(false);
            setDeleteIds([]);
            setallChecked(false);
            setshowLoader(true);
        } catch (error) { }
    };

    const clearSearchBox = () => {
        childRef.current.clearSearchBox();
    };

    const resetPagination = () => {
        setCurrentPage(0);
    };

    useImperativeHandle(ref, () => ({
        clearSearchBox,
        resetPagination,
    }));

    return (
        <React.Fragment>
            <div className="table_filter_box_cover">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="table_filter_inner_box">
                            <GlobalSearch
                                ref={childRef}
                                getSearchData={getSearchData}
                                helperText={props.helperText || null}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        {props?.type === 'transporterbids' || props?.type === 'othersbids' ? (
                            <NavLink
                                to={props?.type === 'transporterbids' ? '/home/demands' : '/home/others'}
                                className="btn custom_btn border_btn with_icon add_box_delete_btn"
                                style={{ float: 'right' }}
                            >
                                Back
                            </NavLink>
                        ) : props?.type === 'finalised' ||
                            props?.type === 'finalised_other_vendor' ||
                            props?.type === 'vendordelay' ? (
                            ''
                        ) : (
                            <>
                                <div
                                    className="table_add_inner_box add_box"
                                    style={deleteshow ? { display: 'none' } : { display: 'flex' }}
                                >
                                    {props?.showAddButton == false ? (
                                        <></>
                                    ) : actionsPermissionValidator(location.pathname, ActionValues.Add) ? (
                                        <>
                                            <a
                                                className="btn custom_btn fill_btn with_icon"
                                                href="javascript:void(0)"
                                                onClick={() => handelModel(true)}
                                            >
                                                <span className="mat_icon material-symbols-outlined">add</span>Add{' '}
                                                {props.addUpdateText}
                                            </a>
                                            {props.type === 'transporter' || props.type === 'others' ? (
                                                <a
                                                    className="btn custom_btn unfillbulk_btn  with_icon"
                                                    href="javascript:void(0)"
                                                    onClick={() => setShowHideModel(true)}
                                                >
                                                    <span className="material-symbols-outlined">upload</span>
                                                    <span
                                                        className="d-flex"
                                                        style={{
                                                            justifyContent: 'space-between',
                                                            flexDirection: 'row',
                                                        }}
                                                    >
                                                        Bulk Upload{' '}
                                                    </span>
                                                </a>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    ) : (
                                        ''
                                    )}

                                    {props?.showDeleteButton == false ? (
                                        <></>
                                    ) : actionsPermissionValidator(location.pathname, ActionValues.Delete) ? (
                                        <a
                                            className="btn custom_btn border_btn with_icon add_box_delete_btn"
                                            href="javascript:void(0)"
                                            onClick={() => {
                                                setDeleteShow(true);
                                            }}
                                        >
                                            <span className="mat_icon material-symbols-outlined">delete</span> Delete{' '}
                                            {props.addUpdateText}
                                        </a>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div
                                    className="table_add_inner_box delete_box"
                                    style={deleteshow ? { display: 'flex' } : { display: 'none' }}
                                >
                                    {deleteIds?.length > 0 && (
                                        <a
                                            className="btn custom_btn orange_btn with_icon"
                                            href="javascript:void(0)"
                                            data-bs-toggle="modal"
                                            data-bs-target="#conform_delete_box"
                                        >
                                            <span className="mat_icon material-symbols-outlined">delete</span>Delete{' '}
                                            {props.addUpdateText}
                                        </a>
                                    )}

                                    <a
                                        className="btn custom_btn border_btn with_icon delete_box_delete_btn"
                                        href="javascript:void(0)"
                                        onClick={() => {
                                            setDeleteShow(false);
                                            handleCancel();
                                        }}
                                    >
                                        Cancel
                                    </a>
                                </div>
                            </>
                        )}

                        {props.bulkUpload && props.type === 'transporter' ? (
                            <BulkUpload
                                locationData={props.locationData}
                                userData={props.userData}
                                type={props.type}
                                demandType={props.demandType}
                                showHideModel={showHideModel}
                                setShowHideModel={setShowHideModel}
                            />
                        ) : (
                            <BulkUpload
                                category={props.categoryData}
                                userData={props.userData}
                                type={props.type}
                                demandType={props.demandType}
                                showHideModel={showHideModel}
                                setShowHideModel={setShowHideModel}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className="table_box_cover">
                <div className="table_box_inner_box">
                    <table className="dataTable display manage_Penalty_table" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th
                                    className="no-sort all_check_box check_box option_box sorting_disabled sorting_asc"
                                    style={
                                        deleteshow
                                            ? { display: 'table-cell', width: '13px' }
                                            : { display: 'none', width: '13px' }
                                    }
                                >
                                    <Checkbox
                                        type="checkbox"
                                        name="selectAll"
                                        id="selectAll"
                                        handleClick={handleSelectAll}
                                        isChecked={allChecked}
                                    />
                                </th>
                                {(props.headTitles || []).map((i: any, j: number) => {
                                    return <th key={j}>{i}</th>;
                                })}
                                {props?.type === 'transporterbids' ||
                                    props?.type === 'othersbids' ||
                                    props?.type === 'vendordelay' ||
                                    props?.type === 'finalised_other_vendor' ||
                                    props?.type === 'finalised' ? (
                                    ''
                                ) : (
                                    <th className="no-sort" style={{ minWidth: '150px', width: '150px' }}>
                                        Status
                                    </th>
                                )}
                                <th className="no-sort">Action {deleteIds?.length > 0 ? deleteIds.length : ''}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list?.length > 0 ? (
                                props.type === 'app_transporter' ? (
                                    listLogAppTransporter
                                ) : props.type === 'app_other' ? (
                                    listLogAppOthers
                                ) : (
                                    listLog
                                )
                            ) : (
                                <tr>
                                    <td
                                        colSpan={props.headTitles?.length + 2}
                                        className="text-center textTransformNone"
                                    >
                                        <div className="td-loader-center">
                                            {showLoader ? (
                                                <>
                                                    <img src={loader} height={25} width={25} />
                                                </>
                                            ) : (
                                                listCount && <>No data found</>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {list?.length > 0 && props.recordCount > recordPerPage && (
                    <div className="pageApp">
                        <p>
                            {/* Showing {(page - 1) * recordPerPage + 1} to{' '}
                            {Math.min(page * recordPerPage, props.recordCount)} of{' '}
                            <span style={{ fontWeight: 600 }}>{props.recordCount}</span> entries */}
                            <span>Total Record : {props.recordCount}</span>
                        </p>
                        <ReactPaginate
                            forcePage={currentPage}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                            pageClassName={'page-item'}
                            onPageChange={(event: any) => getPage(event.selected)}
                            breakLabel="..."
                            pageCount={Math.ceil(props.recordCount / recordPerPage)}
                            previousLabel={
                                <IconContext.Provider value={{ color: '#B8C1CC', size: '36px' }}>
                                    Back
                                </IconContext.Provider>
                            }
                            nextLabel={
                                <IconContext.Provider value={{ color: '#B8C1CC', size: '36px' }}>
                                    Next
                                </IconContext.Provider>
                            }
                        />
                    </div>
                )}
            </div>

            <div
                className="modal fade"
                tabIndex={-1}
                id="conform_delete_box"
                aria-labelledby="logout_popupLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="logout_popupLabel">
                                Delete
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="model">
                                <div className="text_box">
                                    <h3>Are you sure you want to delete all selected records?</h3>
                                    {props.type === 'app_transporter' || props.type === 'app_other' ? (
                                        <p>Users associated with demands and bids, please be careful.</p>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn red_btn custom_btn"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    callDelete();
                                }}
                            >
                                Delete
                            </button>
                            <button type="button" className="btn custom_btn border_btn" data-bs-dismiss="modal">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
});

export default List;
